import { Injectable } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { first } from 'rxjs/operators';
import { MdbModalWrapperService } from 'app/core/services/mdb-modal-wrapper.service';
import { WebHookFormComponent } from '../../modals/web-hook-form/web-hook-form.component';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class WebHookFormModalService {

  public modalRef: MdbModalRef<any> | null = null;

  constructor(
    private modalService: MdbModalWrapperService,
    private store: Store,
  ) { }

  editOrAddWebHook(webHook) {
    if(this.modalRef) {
      return this.modalRef;
    }

    this.modalRef = this.modalService.open(WebHookFormComponent, {
      ignoreBackdropClick: false,
      containerClass:'mdb-modal-backdrop-paybee modal fade show',
      modalClass:'modal-dialog modal-md',
      data: { data: webHook }
    });

    this.modalRef.onClose.pipe(
      first()
    ).subscribe(() => {
      this.modalRef = null;
    });

    return this.modalRef;
  }

  close(message = null) {
    if (this.modalRef) {
      this.modalRef.close(message);
    }
  }

  onTestSendError(errorText){
    const action = DialogActions.openDialog({
      payload:{
        name:"webhookError",
        options:{
          size: 'small',
          modalClass: 'modal--paybee modal-sm',
          containerClass: 'mdb-modal-backdrop-paybee'
        },
        initialState:{
          errorMessage: errorText,
          modalTitle:'Error sending webhook',
        }
      }
    })

    this.store.dispatch(action)
  }

  onResendError(errorText){
    const action = DialogActions.openDialog({
      payload:{
        name:"webhookError",
        options:{
          size: 'small',
          modalClass: 'modal--paybee modal-sm',
          containerClass: 'mdb-modal-backdrop-paybee'
        },
        initialState:{
          errorMessage: errorText,
          modalTitle:'Error resending webhook',
        }
      }
    })

    this.store.dispatch(action)
  }

  onConfirmDelete(header, text, callback) {
    const action = DialogActions.openDialog({
      payload: {
        name: "confirmComponent",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          header, text,
          buttonCancel: "No",
          buttonConfirm: "Yes",
          callback: (value) => {
            if(value) {
              callback();
            }
          }
        }
      }
    });

    this.store.dispatch(action);
  }
}
